import React, { useEffect, useState, createElement } from 'react';
export function usePaystackScript() {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    if (window.PaystackPop) {
      setIsLoaded(true);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    script.onload = () => {
      setIsLoaded(true);
    };
    document.body.appendChild(script);
    return () => {
      // We don't necessarily want to remove the script on unmount
      // as it might be needed again, but good practice to clean up if strictly needed.
      // document.body.removeChild(script);
    };
  }, []);
  return isLoaded;
}